import { store, getContext, getElement } from "@wordpress/interactivity";
import "./view.scss";
import flatpickr from "flatpickr";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
dayjs.extend(customParseFormat);

const updateEventList = () => {
  const context = getContext();

  // Get ALL the events in this updated category
  let search = context.endPoint + "?" + "per_page=100&event_type=" + context.category.id;
  fetch(search)
    .then((response) => {
      return response.json();
    })
    .then((data) => {
      // Filter the response to contain only the event data of interest.
      // Also, create a separate event record for each of the repeated dates
      let filteredData = [];
      data.forEach((entry) => {
        entry.meta.repeatDates.forEach((repeat) => {
          let record = {
            title: entry.title.rendered,
            // Change date format from 'Y-m-d' to 'd-m-Y'
            date: dayjs(repeat).format("DD-MM-YYYY"),
            link: entry.link,
            type: entry.event_type
          };
          filteredData.push(record);
        });
      });
      // Sort the results events into ascending data order
      filteredData.sort((a, b) => {
        let first = dayjs(a.date, "DD-MM-YYYY").unix();
        let second = dayjs(b.date, "DD-MM-YYYY").unix();
        if (first > second) {
          console.log();
          return 1;
        }
        if (first < second) {
          return -1;
        }
        return 0;
      });

      // Extract events that fall in the selected search period period
      context.filteredEvents = [];
      const start = dayjs(context.startDate, "DD-MM-YYYY").unix();
      const end = dayjs(context.endDate, "DD-MM-YYYY").unix();
      filteredData.forEach((entry) => {
        let eventDate = dayjs(entry.date, "DD-MM-YYYY").unix();
        if (eventDate >= start && eventDate <= end) {
          context.filteredEvents.push(entry);
        }
      });

      // Set toggle to show "no events found message" as appropriate
      context.filteredEvents.length !== 0 ? (context.toggleEvents = true) : (context.toggleEvents = false);
    })
    .catch((error) => {
      console.log("Error during fetch: " + error.message);
    });
};
const { state } = store("eventsearch", {
  actions: {
    eventType: () => {
      const context = getContext();
      const { ref } = getElement();
      // Update the event category
      context.category = JSON.parse(ref.options[ref.selectedIndex].getAttribute("data-info"));
      updateEventList();
    },
    dateRange: (e) => {
      const context = getContext();
      const dateRange = e.target.value;
      // Update the period of event occurence
      context.startDate = String(dateRange.substr(0, 10));
      context.endDate = String(dateRange.substr(14, 23));
      updateEventList();
    }
  },
  callbacks: {
    initFlatpickr: () => {
      // Initialise the Flatpickr script
      const context = getContext();
      const { ref } = getElement();
      flatpickr(ref, {
        mode: "range",
        dateFormat: "d-m-Y",
        defaultDate: [context.startDate, context.endDate]
      });
    },
    initEventList: () => {
      // Get the initial list of events for the default category and default period of occurence
      updateEventList();
    }
  },
  state: {}
});
